import { render, staticRenderFns } from "./tenants-dialog.vue?vue&type=template&id=0b5b45f3&scoped=true"
import script from "./tenants-dialog.vue?vue&type=script&lang=js"
export * from "./tenants-dialog.vue?vue&type=script&lang=js"
import style0 from "./tenants-dialog.vue?vue&type=style&index=0&id=0b5b45f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b45f3",
  null
  
)

export default component.exports